module.exports = __webpack_public_path__ + "img/answer_nothing.56750dda.png";